import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';
import axios from 'axios';
import PartnerInfoForm from './PartnerInfoForm';
import SearchBusinesses from '../SearchBusinesses';

const PartnerBusinessesModal = props => {
  const { partner } = props;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [businesses, setBusinesses] = useState([...partner.businesses] || []);
  const [businessesToDelete, setBusinessesToDelete] = useState([]);

  // tells us if a new business has been added to the original list
  const [businessesChanged, setBusinessesChanged] = useState(false);

  const token = sessionStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const onSubmit = async () => {
    try {
      setIsSubmitting(true);

      let updatedPartner = { ...partner };

      if (businessesChanged) {
        const { data } = await addBusinesses();

        updatedPartner = data;
      }

      if (businessesToDelete.length) {
        const { data: deleteData } = await deleteBusinesses();

        updatedPartner = deleteData;
      }

      props.onSuccess(updatedPartner);
    } catch (e) {
      console.log(e.response || e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const addBusinesses = () => {
    const payload = createPayload();
    return axios.post(
      `api/proxy/v2/partneradmin/${partner.id}/businesses`,
      payload,
      { headers }
    );
  };

  const deleteBusinesses = () => {
    return axios.delete(`api/proxy/v2/partneradmin/${partner.id}/businesses`, {
      data: { businesses: businessesToDelete },
      headers,
    });
  };

  // todo: Include support for 'neighborhood' in the payload
  const createPayload = () => {
    return {
      businesses: businesses.map(b => ({
        businessId: b.id,
      })),
    };
  };

  const onBusinessSelect = selected => {
    return e => {
      e.stopPropagation();

      const { name, id } = selected;

      const newBusiness = { name, id };

      setBusinessesChanged(true);

      // use Set as a hack to avoid duplicates if the user clicks same business twice
      setBusinesses(prevValue => {
        return Array.from(new Set([...prevValue, selected]));
      });
    };
  };

  const removeBusiness = index => {
    return () => {
      const toDelete = businesses[index];

      // check if removed business has already been saved to back end, not added and removed in this view before saving
      const businessHasPersisted = partner.businesses.some(
        b => b.id === toDelete.id
      );

      if (businessHasPersisted) {
        setBusinessesToDelete(prevValue => [
          ...prevValue,
          { businessId: toDelete.id },
        ]);
      }

      setBusinesses(prevValue => [
        ...prevValue.slice(0, index),
        ...prevValue.slice(index + 1),
      ]);
    };
  };

  const renderSelected = () =>
    businesses.map((b, idx) => (
      <div className='pill' key={b.id}>
        {b.name}{' '}
        <i
          onClick={removeBusiness(idx)}
          className='icon-close'
          style={{ fontSize: 16, marginLeft: 5, cursor: 'pointer' }}
        />
      </div>
    ));

  return (
    <Modal isOpen={props.isOpen} className={props.className}>
      <ModalHeader toggle={props.close}>Partner Businesses</ModalHeader>
      <ModalBody>
        <div className='pill-container'>
          {renderSelected()}
          <Button
            onClick={onSubmit}
            style={{ backgroundColor: '#20bed6', color: '#fff' }}
            className='pull-right'>
            {isSubmitting && (
              <i
                className='fa fa-circle-o-notch fa-spin'
                style={{ marginRight: 5 }}
              />
            )}
            Save
          </Button>
        </div>

        <div style={{ height: '50%', overflowX: 'hidden' }}>
          <SearchBusinesses onSelect={onBusinessSelect} />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PartnerBusinessesModal;



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/PartnerBusinessesModal.js